import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'sal_center': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
}

export default {
  'plan_cntr_no': {
    title: '单据编号',
    type: 'input',
    equation: all,
    width: 100,
    slot: true,
  },
  'order_type': {
    describe: true,
    suffix: '_text',
    title: '单据类型',
    width: 150,
    type: 'select',
    dictionary: 'A0072'
  },
  'chg_plan_cntr_no': {
    title: '变更签约单号',
    type: 'input',
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'sal_center_text': {
    title: '营销单元'
  },
  'plan_type': {
    describe: true,
    suffix: '_text',
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200
  },
  'chfl': {
    describe: true,
    suffix: '_text',
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 200
  },
  // 'his_plan_qty': {
  //   title: '历史计划量',
  // },
  // 'invoice_qty': {
  //   title: '开票数量',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'shipped_qty': {
  //   title: '发货数量',
  //   width: 180,
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'viola_qty': {
  //   title: '违规数量',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  'pre_aloc_plan_qty': {
    title: '建议签约数量',
    width: 120,
    xlsxFmt: {
      t: 'n'
    }
  },
  'pre_aloc_min_qty': {
    title: '建议签约下限',
    width: 120,
    xlsxFmt: {
      t: 'n'
    }
  },
  'pre_aloc_max_qty': {
    title: '建议签约上限',
    width: 120,
    xlsxFmt: {
      t: 'n'
    }
  },
  'aloc_total_qty': {
    title: '月度计划量合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_12': {
    title: '12月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_1': {
    title: '1月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_2': {
    title: '2月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_3': {
    title: '3月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_4': {
    title: '4月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_5': {
    title: '5月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_6': {
    title: '6月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_7': {
    title: '7月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_8': {
    title: '8月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_9': {
    title: '9月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_10': {
    title: '10月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_qty_11': {
    title: '11月份计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'combination_amt': {
    title: '可组合签约产品年销售金额（万/年）',
    width: 240
  },
  'approval_no': {
    title: 'OA审批单号',
    type: 'input',
  },
  'status': {
    title: '状态',
    equation: all,
    describe: true,
    suffix: '_text',
    type: 'select',
    dictionary: 'A0071',
  },
  'changin_date': {
    title: '计划部审核日期',
    width: 130,
  },
  'changin_time': {
    title: '计划部审核时间',
    width: 130,
  },
  'is_approve': {
    title: '需审核签约单',
    width: 110,
    slot: true,
    dictionary: 'B0099',
    type: 'select',
  },
}



// WEBPACK FOOTER //
// ./src/views/qy-manage/config/salePlanNewList.js